import { Box, Text, BoxProps, HStack, Stack } from "@chakra-ui/react";
import { FavoriteItem } from "@/types/favorites";
import { forwardRef } from "react";
import Image from "next/image";
import { getImageSrc } from "@/utils/file";
import { beautifyPrice } from "@/utils/price";
import ProductFavoriteButton from "./ProductFavoriteButton";
import { I18nLink } from "../i18n/I18nLink";
import { makeProductPageUrl } from "@/utils/product";

type FavoriteItemCardProps = {
  item: FavoriteItem;
} & BoxProps;

const FavoriteItemCard = forwardRef<HTMLDivElement, FavoriteItemCardProps>(
  ({ item, ...boxProps }, ref) => {
    return (
      <I18nLink href={makeProductPageUrl(item.product!)}>
        <Box ref={ref} {...boxProps} paddingBlock={4} paddingInline={2} position={"relative"}>
          <Box position="absolute" top="12px" right="12px" zIndex={1}>
            <ProductFavoriteButton product={item.product!} />
          </Box>
          <Image
            src={getImageSrc(item.product ?? item.giftBox, "main")}
            alt={item.product?.name ?? item.giftBox?.name ?? "Favorite item image"}
            width={100}
            height={215}
            style={{ objectFit: "cover", width: "100%", height: "215px" }}
          />
          <Stack gap={"12px"}>
            <Text
              className="favorite-item-name"
              textStyle={"bold16"}
              as={"b"}
              lineHeight={"20px"}
              lineClamp={2}
              minHeight={"2.5em"}
            >
              {item.product?.name ?? item.giftBox?.name}
            </Text>
            <HStack gap={"4px"}>
              {item.product ? (
                <>
                  <Text as={"b"} className="product-price">
                    {beautifyPrice(item.product.price)}
                  </Text>
                  {item.product.price < item.product.regularPrice && (
                    <Text className="product-price" textStyle={"bold14"} color="text.secondary_light" textDecoration={"line-through"}>
                      {beautifyPrice(item.product.regularPrice)}
                    </Text>
                  )}
                </>
              ) : (
                <Text as={"b"} className="product-price">
                  {beautifyPrice(item.giftBox?.minPrice)}
                </Text>
              )}
            </HStack>
          </Stack>
        </Box>
      </I18nLink>
    );
  }
);

FavoriteItemCard.displayName = "FavoriteItemCard";

export default FavoriteItemCard;